// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"f0db6b95","694":"5c4cf6c0"}[chunkId] + ".chunk.js";
};